var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"char-count-wrap"},[_c('span',{staticClass:"char-count"},[(_vm.remaining === 0)?_c('span',{staticClass:"valid"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("check_circle")])],1):_vm._e(),_vm._v(" "),(_vm.remaining !== 0)?_c('span',[_vm._v("more "+_vm._s(_vm.remaining)+" chars required")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-150b1628","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CharacterCount.vue
// module id = 912
// module chunks = 1